import { render, staticRenderFns } from "./AppDataTableEntriesDisplay.vue?vue&type=template&id=e9e8a6aa&scoped=true&"
import script from "./AppDataTableEntriesDisplay.vue?vue&type=script&lang=js&"
export * from "./AppDataTableEntriesDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9e8a6aa",
  null
  
)

export default component.exports